var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "small-edit-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27435",
    "data-name": "Rectangle 27435",
    width: 11,
    height: 11,
    transform: "translate(826 448.279)",
    fill: "#7e59d1",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_400",
    "data-name": "Mask Group 400",
    transform: "translate(-826 -448.279)",
    clipPath: "url(#small-edit-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_39_",
    "data-name": "svgexport-6 (39)",
    transform: "translate(826 448.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10471",
    "data-name": "Group 10471",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10648",
    "data-name": "Path 10648",
    d: "M6.961,1.9,9.238,4.173,3.474,9.937,1.2,7.66Zm4-.549L9.95.331a1.008,1.008,0,0,0-1.424,0L7.554,1.3,9.831,3.581l1.135-1.135A.776.776,0,0,0,10.966,1.346ZM.006,10.86a.259.259,0,0,0,.313.308l2.537-.615L.581,8.276Z",
    transform: "translate(0 -0.037)",
    fill: "#7e59d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallEditIcon);
export default __webpack_public_path__ + "static/media/small-edit-icon.333060803d8e34e50a8dd66a3f4b8b9d.svg";
export { ForwardRef as ReactComponent };